import angular from 'angular';

import SourceModel from '../../models/source';
import SourcesTreeModel from '../../models/trees/sources';
import AccountModel from '../../models/account';

import BoxServ from '../../services/box';
import DropboxServ from '../../services/dropbox';
import ClioServ from '../../services/clio';
import SourceInfoServ from '../../services/source-info';

class SourcesCtrl {
  constructor($scope, $routeParams, $filter, $sanitize, Source, SourcesTree,
    CurrentAccount, Box, Dropbox, $timeout, $q, SourceInfoServ, $parse,
    $httpParamSerializerJQLike,Clio) {
    // account.integrations.box.connected determines Box type visibility
    this.scope = $scope;
    this.q = $q
    this.routeParams = $routeParams;
    this.account = CurrentAccount;
    this.filterName = $filter('filter');
    this.orderBy = $filter('orderBy');
    this.boxServ = Box;
    this.dropboxServ = Dropbox;
    this.clioServ = Clio;
    this.model = Source;
    this.sourceInfo = SourceInfoServ;
    this.paramSerializer = $httpParamSerializerJQLike

    // default view settings
    this.searchQuery = '';
    this.typeFilter = '';
    this.sortFilter = '-id';

    // declare dropdown state so it can be toggled programatically
    this.newSourceDropdown = {
      isOpen: false
    };

    // Source type metadata used for display
    var sourceType;
    this.sourceIntegrations = {};
    this.sourceTypes = Object.keys(SourceInfoServ.sourceTypes).map(key => {
      sourceType = SourceInfoServ.sourceTypes[key];
      sourceType.name = key;
      if (sourceType.integration &&
        !(sourceType.disabled = !$parse('integrations.' + key +
          '.connected')(this.account.data))) {
        this.sourceIntegrations[key] = sourceType;
        this.setCurrentFolder({}, key);
      }
      return sourceType;
    });

    this.sourcesTree = SourcesTree;
    this.getSources();
    $scope.$on('$routeChangeSuccess', this.getSources);

  }
  getSources() {
    if (this && this.routeParams.caseId) {
      this.sourcesTree.api.get().then(() => {
        this.sourcesTree.setData(this.getLinks(this.sourcesTree.data));
        this.filterSources();
      });
    }
  }
  getLinks(sourcesTree) {
    sourcesTree.forEach(sourceType => {
      if (sourceType.children) {
        sourceType.children =
          sourceType.children.map(
            source => this.sourceInfo.getLink(source.data, this.routeParams
              .caseId)
          );
      }
    })
    return sourcesTree;
  };
  setCurrentFolder(folder, format) {
    folder = folder || {};
    format = format || this.selectedSource.format;

    var integration = this.sourceIntegrations[format];
    integration.currentFolder = integration.currentFolder || {};

    if (integration.currentFolder.updating) {
      return;
    }
    integration.currentFolder.updating = true;
    ({
      'box': this.boxServ,
      'dropbox': this.dropboxServ,
      'clio': this.clioServ
    }[format]).getFolder({
      id: folder.id
    }, function (data) {
      // actual resources have different structure, don't forget
      // to change for real data
      integration.currentFolder = data;
      integration.currentFolder.pathCollection = data.pathCollection.reverse();
      integration.currentFolder.updating = false;

    }, function () {
      integration.currentFolder.name = 'Error';
      integration.currentFolder.entries = [{
        name: 'Could not connect to ' + integration.displayName
      }];
      integration.currentFolder.updating = false;
    });
  };

  selectBoxItem(item, format) {
    format = format || this.selectedSource.format;

    if (item.itemType === 'folder') {
      this.setCurrentFolder(item, format);
    } else if (item.itemType === 'file') {
      var source = new this.model(item);
      source.api[{
        'box': 'linkBoxFile',
        'dropbox': 'linkDropboxFile',
        'clio': 'linkClioFile'
      }[format]]().then(
        (data) => {
          this.updateModel(data);
        }, (response) => {});

    }
  };

  // used to toggle the new Source dropdown
  toggleDropdown(e) {
    e.preventDefault();
    e.stopPropagation();
    this.newSourceDropdown.isOpen = !this.newSourceDropdown.isOpen;
  };

  updateModel(data, isUpdate) {
    this.selectedSource = this.sourceInfo.getLink(data, this.routeParams.caseId);
    this.setDetail(this.selectedSource);

    var formatIndex = this.sourcesTree.data
      .map(sourceType => sourceType.id)
      .indexOf(this.selectedSource.format);

    if (formatIndex === -1) {
      // For the first source of its format
      this.sourcesTree.data.push({
        id: data.format,
        displayName: this.sourceInfo.sourceTypes[this.selectedSource.format]
          .displayName,
        children: [this.selectedSource]
      });
    } else {
      // Add or replace data in tree
      var sourceType = this.sourcesTree.data[formatIndex];
      var index = sourceType.children.map(
        child => child.id
      ).indexOf(this.selectedSource.id);
      if (index === -1) {
        sourceType.children.push(this.selectedSource);
      } else {
        sourceType.children[index] = this.selectedSource;
      }
    }

    this.toggle(this.selectedSource);
    // the source list should be refreshed if updating a source.
    // the filtered list should contain the new source after adding,
    // regardless of filtering - temporarily add the new source onto
    // the filtered list.
    if (isUpdate) {
      this.filterSources();
    } else if (!this.filteredSources.some(function (source) {
        // test if new source is in filtered list
        // special-case (when re-uploading a file)
        return source.id === data.id;
      })) {

      this.filteredSources.unshift(data);
    }

  };
  addFiles(files) {
    files.forEach(file => this.updateModel(file))
  }
  saveSource() {
    this.detail.updating = true;

    // Set the note displayName to note text (until used throughout app)
    if (this.selectedSource.format === 'note') {
      this.selectedSource.displayName =
        this.selectedSource.text;
    }

    var newSource = new this.model(this.selectedSource);

    if (newSource.data.id) {
      let promise = newSource.api.update();
      promise.then(data => {
        this.updateModel(data, true);
      }, r => {
        this.detail.error = r.data.data;
        this.detail.updating = false;
      });
      return promise;
    } else {
      let promise = newSource.api.create({}, this.paramSerializer(newSource.data))
      promise.then(data => {
        for (var i = 0; i < data.sources.length; i++) {
          this.updateModel(data.sources[i]);
        }
      }, r => {
        this.detail.error = r.data.data;
        this.detail.updating = false;
      });
      return promise;
    }
  };
  $onInit() {
    // fb-source-selector component method
    this.reset()
  }
  $onChanges(changesObj) {
    this.reset()
  }
  reset() {
    // fb-source-selector component method
    this.newValue = this.value ? angular.copy(this.value) : []
  }
  toggle(value) {
    // fb-source-selector component method
    const index = this.newValue.map(i => i.id).indexOf(value.id)
    if (index >= 0) {
      this.newValue.splice(index, 1)
    } else {
      this.newValue.push(value)
    }
    if (this.onUpdate) {
      this.onUpdate({ newValue: this.newValue })
    }
  }
  addBookmark(displayName, parent) {
    // fb-source-selector component method
    // called from fb-li-select, with source object passed as parent
    const deferred = this.q.defer() // promise for fb-li-select flow

    // ensure displayName is valid, otherwise return rejected promise
    const match = displayName.replace(/\s/g, '').match(/\d+(-\d+)?/g)
    const page = match ? match[0] : null

    if (!page) {
      deferred.reject()
      return deferred.promise
    }

    // update newValue, since bookmarks is an object property (unwatched)
    this.reset()

    // find the index of the source we are adding bookmarks to
    const index = this.newValue.map(i => i.id).indexOf(parent.id)

    // get or create the array of bookmarks
    var bookmarks = index >= 0 ? this.newValue[index].bookmarks : []
    bookmarks = bookmarks || [] // ensure we have an array to push to
    const bIndex = bookmarks.map(b => b.page).indexOf(page)
      // add bookmark if not present
    if (bIndex === -1) {
      bookmarks.push({ page })
    }
    // add source if not selected
    if (index === -1) {
      this.newValue.push({...parent, bookmarks })
    } else {
      this.newValue[index].bookmarks = bookmarks
    }

    this.onUpdate({ newValue: this.newValue })

    deferred.resolve()
    return deferred.promise

  }
  removeBookmark(value, parent) {
    // fb-source-selector component method
    // get latest, since bookmarks is an obj prop, not an obj in wathed array
    // called from fb-li, so source passed as parent, value is {page}
    this.reset()

    const index = this.newValue.map(i => i.id).indexOf(parent.id)

    var bookmarks = this.newValue[index].bookmarks
    const bIndex = bookmarks.map(b => b.page).indexOf(value.page)

    if (bIndex !== -1) {
      bookmarks.splice(bIndex, 1)
    }

    this.newValue[index].bookmarks = bookmarks

    this.onUpdate({ newValue: this.newValue })
  }
  deleteSource(data) {
    if (window.confirm('Are you sure you want to delete ' + data.displayName +
        '?')) {

      this.detail.updating = true;

      var source = new this.model(data);
      source.api.delete().then(() => {
          // select the next Source in filtered Sources
          var index = this.filteredSources.indexOf(this.selectedSource);

          this.sourcesTree.remove(data);

          this.filterSources();
          this.setDetail(this.filteredSources[index]);

          // focus the list item in the ui to reflect selected state
          // $timeout(function () {
          angular.element('#source-manager-list .active').focus();
          // });
        },
        function () {
          this.detail.updating = false;
        }
      );
    }
  };

  selectDefault() {
    // keep selection if selected Source is in filtered Sources
    // otherwise set selected Source to first in filtered Sources
    this.setDetail(
      this.filteredSources.indexOf(this.selectedSource) !== -1 ?
      this.selectedSource :
      this.filteredSources[0]
    );
  };
  getDetailPanel() {
    // let panel = angular.element('#source-selector-sidebar-container');
    // return {
    //   element: panel,
    //   background: panel.find('> .sidebar-background'),
    //   list: panel.find('> .source-selector-sidebar')
    // };
  }
  showDetailPanel() {
    //   let panel = this.getDetailPanel();
    //   panel.element.show();
    //   panel.list.animate({
    //     right: 0
    //   });
    //   panel.background.fadeIn();
  };

  hideDetailPanel() {
    // let panel = this.getDetailPanel();
    // panel.background.fadeOut('fast');
    // panel.list.animate({
    //   right: '-30rem'
    // }, () => {
    //   panel.element.hide();
    // });
  };
  setDetail(source) {
    // set the detail view to (new) Source

    this.selectedSource = source && source.data ? source.data : source;
    // keep a backup if user cancels edit after making changes
    this.backupSource = angular.copy(source);

    // newSource: detail view should show 'new'-specific fields
    // editMode: detail view should show editable fields
    this.detail = source && {
      icon: this.filterName(this.sourceTypes, {
        name: source.format
      })[0].icon,
      template: '/modals/sources/detail.' + source.format + '.html',
      newSource: !source.id,
      editMode: !source.id,
      updating: false
    };
    if (source && this.detail.newSource) {
      // this.showDetailPanel();
    } else {
      this.hideDetailPanel();
    }

  };

  cancelDetail() {
    if (this.selectedSource.id) {
      // cancel should reset detail to selected Source when editing
      this.updateModel(this.backupSource, true);

    } else {
      // cancel should select default source when adding new
      this.selectDefault();
    }
  };

  newSource(selectedFormat) {
    if (this.typeFilter) {
      // the type filter should match the new Source's type
      this.setTypeFilter(selectedFormat, true);
    }

    // set the detail with the new Source
    this.setDetail({
      format: selectedFormat
    });

    // $timeout(function () {
    // New Source should be scrolled to if it is above view
    // angular.element('#source-selector-list > .selector-list').animate({
    //   scrollTop: 0
    // });
    // });
  };

  setTypeFilter(name, isNewSource) {
    this.typeFilter = name;
    this.filterSources(isNewSource);
  };
  setSearchFilter(search) {
    this.searchQuery = search;
    this.filterSources();
  };
  setSortFilter(sortBy) {
    // sort by sources id (last added), or by sortBy (+/- displayName)
    if (this.sortFilter === sortBy) {
      this.sortFilter = '-id';
    } else {
      this.sortFilter = sortBy;
    }
    this.filterSources();
  };

  filterSources(isNewSource) {
    // convert object to array
    this.filteredSources = new Array();
    this.sourcesTree.data.filter(sourceType =>
      this.typeFilter ? sourceType.id === this.typeFilter : true
    ).forEach(sourceType => {
      sourceType.children.forEach(child => {
        child.format = sourceType.id;
        this.filteredSources.push(child);
      })
    });

    if (this.searchQuery) {
      // filter by search query
      this.filteredSources = this.filterName(this.filteredSources, {
        displayName: this.searchQuery
      });
    }
    // order by sortFilter
    this.filteredSources = this.orderBy(this.filteredSources, this.sortFilter);
    if (!isNewSource) {
      // select default Source to open in detail panel
      this.selectDefault();
    }
  };
};
SourcesCtrl.$inject = ['$scope', '$routeParams', '$filter', '$sanitize',
  'Source', 'SourcesTree', 'CurrentAccount', 'Box', 'Dropbox', '$timeout',
  '$q', 'SourceInfoServ', '$parse', '$httpParamSerializerJQLike','Clio'
];

export default angular.module('controllers.sources', [SourceModel,
    SourcesTreeModel,
    AccountModel,
    BoxServ,
    DropboxServ,
    ClioServ,
    SourceInfoServ
  ])
  .controller('SourcesCtrl', SourcesCtrl)
  .name;



// WEBPACK FOOTER //
// ./project/modals/sources/sources.controller.js